// Momo partner code
export const MOMO_PARTNER_CODE = 'MOMO';
